import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useContext, useEffect, useReducer, useState } from "react";
import { ControlContext } from "../WControlProvider/ControlContext";
import { FormGroup } from "../../exports";
export const WFormContext = React.createContext({
  form: new FormGroup({}),
  formLoadedData: null,
  formLoadParams: null,
  formLoadStatus: "",
  formLoadedError: null,
  formSavedData: null,
  formSaveParams: null,
  formSaveStatus: "",
  formSavedError: null,
  submit: () => {},
  submitted: false,
  markAsSubmitted: () => {}
});
export const WForm = props => {
  const {
    formConfig,
    renderOnError,
    children,
    globalErrorMessages
  } = props;
  const {
    submit,
    formLoadStatus,
    form,
    formLoadedError,
    formLoadedData,
    formLoadParams,
    formSaveStatus,
    formSavedError,
    formSavedData,
    formSaveParams,
    reset$
  } = formConfig;
  const [submitted, setSubmitted] = useState(false);
  const [, forceUpdate] = useReducer(x => x + 1, 0);
  useEffect(() => {
    reset$.subscribe(() => {
      setSubmitted(false);
      forceUpdate();
    });
  }, [reset$]);
  const formContextProvider = {
    form,
    formLoadedData,
    formLoadParams,
    formLoadStatus,
    formLoadedError,
    formSavedData,
    formSaveParams,
    formSaveStatus,
    formSavedError,
    submitted,
    markAsSubmitted: () => {
      setSubmitted(true);
    },
    globalErrorMessages,
    submit
  };
  const controlContext = {
    status: formLoadStatus,
    control: form,
    errors: formLoadedError
  };
  const formProps = {
    className: props.className,
    style: props.style
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, formLoadStatus && formLoadStatus !== "FAILURE" && /*#__PURE__*/React.createElement("form", _extends({
    onSubmit: e => {
      e.preventDefault();
      e.stopPropagation();
      setSubmitted(true);
      formConfig.submit(e);
    }
  }, formProps), /*#__PURE__*/React.createElement(ControlContext.Provider, {
    value: controlContext
  }, /*#__PURE__*/React.createElement(WFormContext.Provider, {
    value: formContextProvider
  }, typeof children === "function" ? children(formContextProvider) : children))), formLoadStatus === "FAILURE" && /*#__PURE__*/React.createElement(React.Fragment, null, renderOnError && renderOnError(null)));
};
export const useFormContext = () => {
  const formContext = useContext(WFormContext);
  return formContext;
};